/* eslint-disable no-unused-vars */
import React, { useCallback, memo, useEffect, useState } from "react";
import styled from "styled-components";
import { BsCircle } from "react-icons/bs";
import { useOrochi } from "../context/OrochiContext";
import { useNavigate } from "react-router-dom";
// import { drinksData } from "../data/drinks";
import { useTranslation } from "react-i18next";
import useElementOnScreen from "../utils/useElementOnScreen";
import { useInView } from "react-intersection-observer";

const Drinks = memo(({ windowWidth, handleSelectedCategoryDrinks }) => {
  const [containerRef] = useElementOnScreen({
    root: null,
    rootMargin: "40px",
    threshold: 0.5,
  });
  const { t, i18n } = useTranslation("translation");
  const {
    state: { ersData },
    fetchErsData,
    dispatch,
  } = useOrochi();

  const slug = `orochi-drinks-${i18n.language}`;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const changeBackgroundFn = useCallback(
    (value) => {
      dispatch({ type: "change-menu-bg", payload: value });
    },
    [dispatch]
  );
  const [ref1, inView1] = useInView();
  const [ref2, inView2] = useInView();
  const [ref3, inView3] = useInView();
  const [ref4, inView4] = useInView();
  const [ref5, inView5] = useInView();
  const [ref6, inView6] = useInView();
  const [ref7, inView7] = useInView();
  const [ref8, inView8] = useInView();
  const [ref9, inView9] = useInView();
  const [ref10, inView10] = useInView();
  const [ref11, inView11] = useInView();
  const [ref12, inView12] = useInView();
  const [ref13, inView13] = useInView();
  const [ref14, inView14] = useInView();
  const [ref15, inView15] = useInView();
  const [ref16, inView16] = useInView();
  const navigate = useNavigate();
  useEffect(() => {
    setError(null);
    if (ersData && ersData[slug]) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchErsData(slug)
      .then(() => setLoading(false))
      .catch((err) => {
        setError(err.message || t("error.somethingWentWrong"));
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const drinksData = ersData[slug];
  useEffect(() => {
    let views = [
      inView1,
      inView2,
      inView3,
      inView4,
      inView5,
      inView6,
      inView7,
      inView8,
      inView9,
      inView10,
      inView11,
      inView12,
      inView13,
      inView14,
      inView15,
      inView16,
    ];
    views.map((el, ind) => el === true && handleSelectedCategoryDrinks(ind));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    inView1,
    inView2,
    inView3,
    inView4,
    inView5,
    inView6,
    inView7,
    inView8,
    inView9,
    inView10,
    inView11,
    inView12,
    inView13,
    inView14,
    inView15,
    inView16,
  ]);
  if (loading)
    return (
      <Main className="text-center">
        <div>{t("loading")}</div>
      </Main>
    );
  if (error)
    return (
      <Main>
        <div>{t("error.prefix")}{error}</div>
      </Main>
    );
  if (!drinksData) return null;
  return (
    <Main>
      <section id="cocktails">
        <div ref={ref1}></div>
        <span>
          <h5 ref={containerRef}>{t("categories.cocktails")}</h5>
        </span>
        <div>
          {drinksData?.map((el) =>
            el.category === t("categories.cocktails") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                <p>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </p>
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="mocktails">
        <div ref={ref2}></div>
        <span>
          <h5>{t("categories.mocktails")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.mocktails") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                <p>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </p>
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Beers">
        <div ref={ref3}></div>
        <span>
          <h5>{t("categories.beers")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.beers") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                <p>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </p>
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Tea/Coffee">
        <div ref={ref4}></div>
        <span>
          <h5>{t("categories.teaCoffee")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.teaCoffee") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                <p>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </p>
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Japanese-Whisky">
        <div ref={ref5}></div>
        <span>
          <h5>{t("categories.japaneseWhisky")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.japaneseWhisky") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Vodka">
        <div ref={ref6}></div>
        <span>
          <h5>{t("categories.vodka")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.vodka") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Gin">
        <div ref={ref7}></div>
        <span>
          <h5>{t("categories.gin")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.gin") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Rum">
        <div ref={ref8}></div>
        <span>
          <h5>{t("categories.rum")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.rum") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Tequila/Mezcal">
        <div ref={ref9}></div>
        <span>
          <h5>{t("categories.tequilaMezcal")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.tequilaMezcal") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Scotch-Whisky">
        <div ref={ref10}></div>
        <span>
          <h5>{t("categories.scotchWhisky")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.scotchWhisky") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Whiskey/Bourbon">
        <div ref={ref11}></div>
        <span>
          <h5>{t("categories.whiskeyBourbon")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.whiskeyBourbon") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Cognac/Brandy">
        <div ref={ref12}></div>
        <span>
          <h5>{t("categories.cognacBrandy")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.cognacBrandy") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Amaro">
        <div ref={ref13}></div>
        <span>
          <h5>{t("categories.amaro")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.amaro") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Grappa">
        <div ref={ref14}></div>
        <span>
          <h5>{t("categories.grappa")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.grappa") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      <section id="Liquor">
        <div ref={ref15}></div>
        <span>
          <h5>{t("categories.liquor")}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === t("categories.liquor") ? (
              <span key={Math.random() * 14000}>
                <h6>{el?.name}</h6>
                {el?.pricebtl ? (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl / $${el?.pricebtl} btl`
                      : `${el?.pricegl}$ verre / ${el?.pricebtl}$ btl`}
                  </p>
                ) : (
                  <p>
                    {i18n.language === "en"
                      ? `$${el?.pricegl} gl`
                      : `${el?.pricegl}$ verre`}
                  </p>
                )}
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section>
      {/* <section id="sakes">
        <div ref={ref4}></div>
        <span>
          <h5>{i18n.language === "en" ? "Sakes" : "Sakés"}</h5>
        </span>
        <div ref={containerRef}>
          {drinksData?.map((el) =>
            el.category === "Sakes" ? (
              <span key={Math.random() * 14000}>
                <h6>{i18n.language === "en" ? el.name : el.name_fr}</h6>
                <p>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </p>
              </span>
            ) : null
          )}
          <p></p>
        </div>
      </section> */}
      <section>
        <div ref={ref16}></div>
        <div>
          <a
            ref={containerRef}
            href={`/pdf/Drunken-Dragon_Drink-Menu_${
              i18n.language === "en" ? "EN" : "FR"
            }.pdf`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {i18n.language === "en"
              ? "Complete drink menu"
              : "Menu complet des boissons"}
          </a>
          {/* <a
            href="/pdf/PG_WINE_MENU.pdf"
            rel="noopener noreferrer"
            target="_blank"
          >
            {i18n.language === "en" ? "Wine menu" : "Menu des vins"}
          </a> */}
        </div>
      </section>
    </Main>
  );
});
const Main = styled.main`
  width: 100%;
  height: 100%;
  max-height: calc(80% - 20px);
  scroll-behavior: smooth;
  display: flex;
  flex-flow: column nowrap;
  gap: 20px;
  padding-right: 50px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 8px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: var(--scroll_track);
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--scroll_thumb);
    border-radius: 10px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--scroll_thumb_hover);
  }
  & > section {
    position: relative;
    & > div:first-child {
      position: absolute;
      height: 200px;
      margin-top: 400px;
    }
    & > span {
      display: flex;
      & > h5 {
        width: 100%;
        display: inline-block;
        border-bottom: 1px solid rgba(255, 255, 255, 0.4);
        margin-top: 7px;
        /* margin-left: 10px; */
        padding-bottom: 20px;
        font-weight: 400;
        font-size: 18px;
        text-transform: uppercase;
      }
      & > span {
        margin-right: 10px;
        font-size: 20px;
        color: var(--silver);
        z-index: 4;
      }
    }
    & > div {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 10%;
      /* margin-left: 40px; */
      & > span {
        /* margin-bottom: 15px; */
        /* cursor: pointer; */
        /* padding-left: 5px; */
        height: auto;
        font-weight: 300;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 10px;
        & > h6 {
          margin: 5px 0;
          font-weight: 500;
          max-width: 200px;
          & > small {
            font-weight: 300;
          }
        }
        & > p {
          align-self: flex-start;
          margin: 0;
          font-size: 16px;
          line-height: 30px;
          font-weight: 500;
          text-align: right;
          text-transform: lowercase;
        }
        /* &:hover {
          border: 1px solid var(--silver);
          border-radius: 10px;
          background-color: rgba(255, 255, 255, 0.7);
          color: black;
          & > h6 {
            font-weight: 300;
          }
          & > p {
            font-size: 16px;
            line-height: 30px;
            font-weight: 300;
          }
        } */
      }
    }
  }
  & > section:last-child {
    & > div:last-child {
      padding-top: 25px;
      display: flex;
      justify-content: center;
      text-align: center;
      & > a {
        color: var(--white);
        text-align: center;
        padding: 5px 0;
        border: 1px solid var(--silver);
        border-radius: 10px;
        transition: 0.3s all;
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        max-width: 280px;
        font-weight: 300;
        &:hover {
          background-color: var(--silver);
          color: #101010;
        }
        @media screen and (max-width: 1050px) {
          /* start of phone and medium tablet styles */
          font-size: 14px;
          padding: 10px 0;
          color: var(--silver);
        }
      }
    }
  }
  @media screen and (min-width: 2000px) {
    & > section {
      position: relative;
      & > div:first-child {
        position: absolute;
        height: 100px;
        margin-top: 900px;
      }
    }
    & > section:last-child {
      & > div {
        margin-bottom: 700px;
      }
    }
  }
  @media screen and (max-width: 991px) {
    /* start of phone and medium tablet styles */
    /* display: block; */
    gap: 0;
    padding: 8px 8px 0 0;
    position: relative;
    right: 0;
    left: 0;
    height: auto;
    max-height: calc(100% - 140px);
    ::-webkit-scrollbar {
      width: 2px;
    }
    & > section {
      & > span {
        position: relative;
        width: 100%;
        & > h5 {
          padding-bottom: 16px;
          font-weight: 300;
          font-size: 20px;
        }
        & > span {
          position: absolute;
          left: -20px;
          bottom: 18px;
        }
      }
      & > div:last-child {
        grid-template-columns: 1fr;
        grid-column-gap: 0px;
        margin: 0;
        width: 100%;
        margin-bottom: 45px;
        & > span {
          padding: 0;
          width: 100%;
          margin: 0;
          height: auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          /* &:hover {
            border: none;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 0.6);
          } */
          h6 {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            max-width: 135px;
          }
          p {
            margin: 0;
            line-height: 18px;
          }
        }
      }
    }
    & > section:last-child {
      & > div:first-child {
        margin-top: 0;
      }
      & > div:last-child {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        position: relative;
        z-index: 5;
      }
    }
  }
`;
export default Drinks;
